import React, { Children, cloneElement } from 'react';
// $FlowIgnore
import ReactModal from 'react-modal';

let modalStyles = {
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    position: 'initial', // needed for firefox
    bottom: 'auto',
    right: 'auto',
    left: 'auto',
    top: 'auto',
    width: '40rem',
  }
};

export type modalType = {
  isOpen: boolean;
  onRequestClose: ?() => {};
  style: ?Object;
  children: Object;
}

let Modal = ({
  isOpen,
  onRequestClose,
  style,
  children
}: modalType): React.Element => {
  return (
    <ReactModal
      style={{ ...modalStyles, ...(style || {}) }}
      isOpen={isOpen}
      onRequestClose={onRequestClose || (() => {})}
    >
      {Children.map(children, child =>
        cloneElement(child, { ...child.props, modalWidth: `38rem` })
      )}
    </ReactModal>
  );
};

export default Modal;
